import { checkSocialMedia } from 'utils'
import { MixpanelEditor, MixpanelEditorData } from './editorInterfaces'

export function getEditorData(editorData: MixpanelEditorData): MixpanelEditor {
  return {
    editor_social_channel: checkSocialMedia(editorData?.designType ?? ''),
    editor_format: `${editorData?.width}x${editorData?.height} ${editorData?.measureUnits}`,
  }
}
